import { ChangeDetectionStrategy, Component, computed, input, InputSignal, Signal } from '@angular/core';

interface ProgressSegment {
  readonly active: boolean;
  readonly current: boolean;
}

@Component({
  selector: 'lib-session-progress-indicator',
  templateUrl: './session-progress-indicator.component.html',
  styleUrls: ['./session-progress-indicator.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true
})
export class SessionProgressIndicatorComponent {
  /** 1-based index of the run currently being entered. */
  readonly current: InputSignal<number> = input.required<number>();
  readonly target: InputSignal<number | null> = input.required<number | null>();

  readonly segments: Signal<readonly ProgressSegment[]> = computed((): readonly ProgressSegment[] => {
    const t: number | null = this.target();
    if (t === null || t <= 0) return [];
    const c: number = this.current();
    return Array.from({ length: t }, (_unused: unknown, i: number) => ({
      active: i < c,
      current: i === c - 1
    }));
  });
}
